<template>
  <nav :style="'background-color:'+this.$store.state.empresa.cor_primaria" class="waves-effect">
    <div class="nav-wrapper container">
      <a @click="Voltar()" class="left"><i class="material-icons"
                                           :style="'font-size: 27px;'+colorarrow ? 'color:'+colorarrow : ''">arrow_back</i></a>
      <span style="padding-left: 15px">{{ titulo }}</span>

      <slot></slot>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MenuSuperior",
  props: ["titulo", "colorarrow"],
  methods: {
    Voltar() {
      const previousRoute = this.$router.resolve(this.$router.history.current.fullPath).route;

      if (previousRoute && previousRoute.query.produto) {
        this.$router.push("/" + this.$store.state.empresa_url + "/menu");
      }

      this.$router.back();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Widgets/MenuSuperior.vue